module.exports = __webpack_public_path__ + "static/instalaciones-2-5b6a90923a0ca9dc3f91ae98330e2fa1.jpg";